

import Button from './common/Button.vue';
import Points from './common/Points.vue';
import Tags from './common/Tags.vue';
import { reachGoal } from './utils/metrika.js';

export default {
    name: 'MeatPageHeroSupplier',
    components: { Button, Tags, Points },
    props: {
        data: { type: Object, default: () => ({}) },
        common: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            isVideoPlaying: false
        };
    },
    computed: {
        isYoutube() {
            const url = this.data.under?.video;
            if (!url) return false;
            return /youtube\.com|youtu\.be/.test(url);
        },
        youtubeEmbedUrl() {
            const url = this.data.under?.video;
            if (!url) return '';
            
            let videoId = '';
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);

            if (match && match[2].length === 11) {
                videoId = match[2];
            }

            return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        }
    },
    methods: { reachGoal },
}
